import Request from 'src/utils/request'

/**
 * 获取用户信息
 * @param {*} data
 */
export function getUserInfoApi (data) {
  return Request({
    url: '/user/user_info',
  })
}

/**
 * 退出登录
 * @param {*} data
 */
export function logoutApi (data) {
  return Request({
    url: '/user/logout',
    method: 'post',
  })
}

/**
 * 查询系统信息
 */
export function getSystemInfoApi () {
  return Request({
    url: '/system/info',
    unique: true,
  })
}
